import { create } from 'zustand';

const useDeviceSizeStore = create((set) => ({
    isSmallDevice: false,
    isMediumDevice: false,
    isLargeDevice: false,
    storeDeviceSize: (breakpoint) => set(() => ({
        isSmallDevice: breakpoint === 'xs',
        isMediumDevice: breakpoint === 'md',
        isLargeDevice: breakpoint === 'lg' || breakpoint === 'xl'
    }))
}));

export default useDeviceSizeStore;